/* eslint-disable camelcase, no-redeclare, no-useless-escape */
/* global ppd, jQuery, $, grecaptcha, Cookies, fetch */

import * as Password from 'modules/validPassword'

jQuery(function () {
  // Handle select placeholder styling
  jQuery('select.select_field, select.w-input').each(function () {
    var $select = jQuery(this)

    // Set initial state
    if ($select.val() === '' || $select.val() === null) {
      $select.addClass('placeholder')
    } else {
      $select.removeClass('placeholder')
    }

    // Handle change
    $select.on('change', function () {
      if ($select.val() === '' || $select.val() === null) {
        $select.addClass('placeholder')
      } else {
        $select.removeClass('placeholder')
      }
    })
  })

  var Supershare = (function () {
    var $formEl = jQuery('#signup-form')
    var supershareCaption = $formEl.find('.supershare-password-caption')

    function toggleSupershareCaption () {
      if (window.isSupershare) {
        supershareCaption.attr('style', 'display: block !important')
      } else {
        supershareCaption.attr('style', 'display: none !important')
      }
    }

    return {
      enable: function () {
        window.isSupershare = true
        toggleSupershareCaption()
        jQuery('.password-requirements-wrapper').css('visibility', 'hidden')
      },

      disable: function () {
        window.isSupershare = false
        toggleSupershareCaption()
        jQuery('.password-requirements-wrapper').css('visibility', 'visible')
      }
    }
  })()

  jQuery(function () {
    jQuery.validator.addMethod('fullname', function (value, element) {
      return /\w+\s+\w+/.test(value)
    }, jQuery.validator.format('Please enter your first and last name.'))

    jQuery.validator.addMethod('validPassword', Password.validPassword, '')

    return jQuery('#signup-form').validate({
      submitHandler: function (validForm) {
        $(validForm).find('input[type=submit]').prop('disabled', true)
        $(validForm).find('input[type=submit]').css('cursor', 'not-allowed')

        if (grecaptcha) {
          grecaptcha.ready(function () {
            grecaptcha.execute({ action: 'signup' }).then(function (token) {
              $('#ga_recaptcha_v3_token').prop('value', token)
              validForm.submit()
            })
          })
        } else {
          validForm.submit()
        }
      },

      invalidHandler: function (event, validator) {
      },

      errorPlacement: function (error, element) {
        error.insertAfter(element)
      },

      onkeyup: false,
      rules: {
        'account[users_attributes][0][full_name]': {
          required: true,
          fullname: true
        },
        'account[users_attributes][0][password]': {
          required: true,
          validPassword: window.passwordRequirements,
          remote: {
            depends: function () {
              return window.isSupershare
            },
            param: {
              url: '/api/v3/auth.json?source=marketing',
              type: 'POST',
              data: {
                email_or_username: function () {
                  return $('[name="account[users_attributes][0][work_email]"]').val()
                },
                password: function () {
                  return $('[name="account[users_attributes][0][password]"]').val()
                }
              },
              dataFilter: function (isCorrectPassword) {
                var isCorrectPassword = JSON.parse(isCorrectPassword)
                return Boolean(isCorrectPassword)
              }
            }
          }
        },
        'account[users_attributes][0][work_email]': {
          required: true,
          email: true,
          remote: {
            url: '/verify_email',
            data: {
              email: function () {
                return jQuery('[name="account[users_attributes][0][work_email]"]').val()
              }
            },
            dataFilter: function (data) {
              data = jQuery.parseJSON(data)

              try {
                if (data.message.match(/supershare/i)) {
                  Supershare.enable()
                } else {
                  Supershare.disable()
                }
              } catch (_) {
                Supershare.disable()
              }

              if (data.available) {
                return true
              } else {
                var getStartedEmailValidationPlaceholder = jQuery('#signup-form .get-started-email-validation.error')

                if (getStartedEmailValidationPlaceholder.length) {
                  getStartedEmailValidationPlaceholder.html(data.message).show()
                  return false
                } else {
                  return JSON.stringify(data.message)
                }
              }
            }
          }
        }
      },
      messages: {
        'account[users_attributes][0][work_email]': {
          required: function (rules, element) {
            return 'This field is required.'
          },
          email: function (rules, element) {
            return 'Please enter a valid email address.'
          }
        },
        'account[users_attributes][0][password]': {
          remote: function (rules, element) {
            return 'Password does not match SuperShare account.'
          }
        }
      }
    })
  })

  var bindHints = function ($formElem) {
    var passwordInput = $formElem.find('[name="account[users_attributes][0][password]"]')
    var rulesDisplay = $formElem.find('.password-requirements-wrapper')

    var applyRules = function (e) {
      if (window.isSupershare) return

      var $input = $(e.target)
      var val = $input.val()
      let allValid = true

      var completed = function (selector) {
        var $elem = rulesDisplay.find(selector)
        $elem.addClass('completed')
      }

      var incomplete = function (selector) {
        var $elem = rulesDisplay.find(selector)
        if ($elem.length) {
          $elem.removeClass('completed')
          allValid = false
        }
      }

      Password.containsLowerCase(val, $input)
        ? completed('.lower-case')
        : incomplete('.lower-case')

      Password.containsUpperCase(val, $input)
        ? completed('.upper-case')
        : incomplete('.upper-case')

      Password.containsDigit(val, $input)
        ? completed('.number')
        : incomplete('.number')

      Password.containsSpecialCharacter(val, $input)
        ? completed('.special-character')
        : incomplete('.special-character')

      Password.longEnough(val, window.passwordRequirements.length)
        ? completed('.minimum-length')
        : incomplete('.minimum-length')

      if (allValid) hideRules()
    }

    var displayRules = function (e) {
      if (window.isSupershare) return

      rulesDisplay.removeClass('hidden')
    }

    var hideRules = function (e) {
      rulesDisplay.addClass('hidden')
    }

    passwordInput.on('keyup', applyRules)
    passwordInput.on('focus', displayRules)
    // passwordInput.on('blur', hideRules)
  }

  return bindHints(jQuery('#signup-form'))
})

jQuery(function () {
  // This same code will be run on the marketing site pages.
  // Track specific fields across visits to pages on the marketing site which includes
  // the trial signup form and the demo form (since it can be accessed by non-users).
  // UTM parameters are not preserved if an empty value is encountered.
  // Instead, these are logged each page visit so we can tell which clicks come from
  // various ads or email campaigns.
  // Values of other params are preserved if an empty value is found later (such as mbsy).
  // A lead_id allows metrics to retain a series of all visits from a specific visitor,
  // and later link those visits with a propspect and/or customer.
  // The lead_id is stored in _metrics_lead_id cookie across sessions.
  // Preserving for 90 days.

  function getParam (p) {
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search)
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
  }

  function addTrackedField (fieldName, value, expiration = 90) {
    var domain = RegExp('([^.][^.]*\.[^.][^.]*)$').exec(window.location.hostname)[1] || window.location.hostname
    if (value) {
      Cookies.set(fieldName, value, { path: '/', domain: domain, expires: expiration })
    }
    value = value || Cookies.get(fieldName)
    // Not all fields will have a form field. Some are read from cookies on the server.
    var formField = document.getElementById(fieldName)
    if (formField && value) { formField.value = value }
    return value
  }

  function postToMetrics (fields) {
    if (ppd.pipelineMetricsUrl) {
      var lead_id = Cookies.get('_metrics_lead_id')
      fields.lead_id = lead_id
      fields.caller = '5qRuqTpvND942anptmZ29Vqi0sPTUuYM'
      fetch(`${ppd.pipelineMetricsUrl}/webhooks/leads/lead_event.json`, { method: 'POST', body: JSON.stringify(fields), headers: { 'Content-Type': 'application/json' } })
        .then(response => response.json())
        .then(data => addTrackedField('_metrics_lead_id', data.lead_id))
    }
  }

  postToMetrics(
    {
      mbsy: addTrackedField('mbsy', getParam('mbsy')),
      referral_code: addTrackedField('referral_code', getParam('referral_code')),
      mid: addTrackedField('mid', getParam('mid')),
      ga_medium: getParam('utm_medium'),
      ga_source: getParam('utm_source'),
      ga_campaign: getParam('utm_campaign'),
      ga_term: getParam('utm_term'),
      ga_content: getParam('utm_content'),
      utm_id: getParam('utm_id'),
      utm_mt: getParam('utm_mt'),
      utm_dev: getParam('utm_dev'),
      utm_devicemodel: getParam('utm_devicemodel'),
      utm_cid: getParam('utm_cid'),
      utm_agid: getParam('utm_agid'),
      fbclid: getParam('fbclid'),
      msclkid: getParam('msclkid'),
      gclid: getParam('gclid'),
      ga_client_id: getParam('_ga'),
      gid: getParam('_gid'),
      industry: addTrackedField('industry', getParam('industry')),
      account_type: addTrackedField('account_type', getParam('account_type')),
      pathname: window.location.pathname,
      referrer: document.referrer
    }
  )
})
